module.exports = __webpack_public_path__ + "static/media/vgu-login-banner1.c2c4ca22.png";